<template>
    <div>
        <div class="row justify-content-center">
            <div class="col-11 col-xs-11 col-md-6">
                <form>
                    <div class="form-group">
                        <label for="contactName">Your Name</label>
                        <input type="text" class="form-control" id="contactName" placeholder="Enter your name" :readonly="isLoggedIn" v-model="model.name">
                        <div class="form-error u-pt1" v-if="errors.name">{{errors.name}}</div>
                    </div>
                    <div class="form-group">
                        <label for="contactEmail">Your Email</label>
                        <input type="text" class="form-control" id="contactEmail" placeholder="Enter your email address" :readonly="isLoggedIn" v-model="model.email">
                        <div class="form-error u-pt1" v-if="errors.email">{{errors.email}}</div>
                    </div>
                    <div class="form-group">
                        <label for="contactMessage">Your Message</label>
                        <textarea class="form-control" id="contactMessage" rows="6" placeholder="Ask us a question or send us some feedback" v-model="model.message"></textarea>
                        <div class="form-error u-pt1" v-if="errors.message">{{errors.message}}</div>
                    </div>

                    <br>

                    <div class="u-mt1 text-center" v-if="posting">
                        <i class="fas fa-circle-notch fa-spin fa-3x"></i>
                    </div>
                    <div v-else>
                        <ion-button shape="round" expand="full" v-on:click="sendMessage()">Send your message</ion-button>
                    </div>
                </form>
            </div>
        </div>
        <return-home />
    </div>
</template>

<script>
import ReturnHome from '@/components/ReturnHome.vue'
import {formatting} from '@/mixins/formatting';
import {alerts} from '@/mixins/alerts';

export default {
    name: 'profile',
    data : function () {
        return {
            posting : false,
            errors : {},
            model : {
                name : '',
                email : '',
                message : ''
            }
        }
    },
    mounted : function () {
        if (this.isLoggedIn) {
            this.model.name = this.$root.user.name;
            this.model.email = this.$root.user.email;
        }
    },
    components: {
        ReturnHome
    },
    mixins : [formatting, alerts],
    computed : {
        isLoggedIn : function () {
            if (this.$root.user.id) {
                return true;
            }
            return false;
        }
    },
    methods : {
        validateEmail : function (email) {
            if (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,12})+$/.test(email)) {
                return true;
            }
            return false;
        },
        back : function () {
            this.$router.push({name : 'home'});
        },
        validate : function () {
            let errors = {}
            if (_.trim(this.model.name) == '') {
                errors.name = 'Please provide your name';
            }
            if (_.trim(this.model.email) == '') {
                errors.email = 'Please provide your email address';
            } else if (!this.validateEmail(this.model.email)) {
                errors.email = 'Please provide a valid email address';
            }
            if (_.trim(this.model.message) == '') {
                errors.message = 'Please provide a message';
            }
            this.errors = errors;
            return _.size(errors) == 0;
        },
        sendMessage : function () {
            // validate
            let self = this;
            this.posting = true;
            if (!this.validate()) {
                var error = 'Please check the details you have provided and try again';
                this.showError(error);
                this.posting = false;
                return;
            }
            // send
            this.axios.post(this.api + 'contact-form', this.model)
                .then(response => {
                    self.posting = false;
                    self.showSuccess('Thanks, we will be in touch shortly', function () {
                        self.back();
                    });
                })
                .catch(error => {
                    self.posting = false;
                    self.showError('There was a problem processing that request');
                })
        }
    }
}
</script>